export const serviceData = [
    {
        title: `<span> שירות תוכן ו/או מידע <span class='extra'> בתשלום חד פעמי </span></span>`,
        services: [
            {
                value: `קבלת או הורדת תוכן באמצעות האינטרנט, צפייה בו ו/או האזנה לו באופן חד פעמי (כגון: הורדה או צפייה בסרט וידאו, האזנה לשיר, הורדת רינגטון, הורדת סרט וידאו, הורדת משחק, והכל באופן חד-פעמי)`,
                type: 'GIS1',
            },
            {
                value: `שליחת מסרון בתשלום מיוחד לשם הצבעה במסגרת תוכנית המשודרת בטלוויזיה באופן חד פעמי (כגון: הצבעה לתוכנית ריאליטי, באופן חד פעמי)`,
                type: 'GIS2',
            },
            {
                value: `מתן תרומה באמצעות שליחת מסרון באופן חד פעמי (כגון: תרומה לאגודה באופן חד פעמי)`,
                type: 'GIS3',
            },
            {
                value: `קבלת מידע שימושי באופן חד פעמי (כגון: מידע על קווי תחבורה, בעלי מקצוע, מידע פיננסי, הודעה בעניין קבלת דבר דואר רשום והכול באופן חד פעמי)`,
                type: 'GIS4',
            },
            {
                value: `קבלת תוכן באופן חד פעמי (כגון: חידון, הגרלה, סקר, משאל, תחזית אסטרולוגית, קבלת קישור להורדת סרטון וידאו והכל באופן חד פעמי)`,
                type: 'GIS5',
            },
        ],
    },
    {
        title: `<span>שירות תוכן ו/או מידע <span class='extra'>בתשלום מתמשך - מנוי </span></span>`,
        services: [
            {
                value: `קבלת או הורדת תוכן באמצעות האינטרנט צפייה בו ו/או האזנה לו שלא באופן חד פעמי (כגון מנוי להורדה או צפייה בסרט וידיאו, מנוי לשירות מוזיקה, מנוי להורדת רינגטונים, מנוי להורדת סרטי וידאו ומנוי להורדת משחקים)`,
                type: 'GIS6',
            },
            {
                value: `קבלת תוכן ו/או מידע שלא באופן חד פעמי (כגון: מנוי לקבלת עדכוני חדשות, מנוי לקבלת תוצאות ספורט, מנוי לקבלת שאלות טריוויה , מנוי לקבלת מתכוני דיאטה)`,
                type: 'GIS7',
            },
        ],
    },
    {
        title: `<span><span class='extra'>גישה לשירות פרימיום,</span></br><span>הכולל השמעת תוכן קולי או הצגת תוכן חזותי, כגון: מידע, בידור, ייעוץ, שירות היכרויות, השתתפות בתחרויות וכו', הניתן באמצעות חיוג למספר הכולל את קידומות החיוג 1-900 ו- 1-901</span></span>`,
        services: [
            {
                value: `מספרים בקידומת 1-900 בתעריף של עד 50 אג' לדקה ולא יותר מ-30 ₪ לשיחה כולה`,
                type: 'PRE0',
            },
            {
                value: `מספרים בקידומת 1-901 בתעריף שאינו עולה על 50 ₪ לשיחה כולה`,
                type: 'PRE1',
            },
        ],
    },
    {
        title: `<span class='extra'> שירות שיחות לחו"ל</span>`,
        services: [
            {
                value: ``,
                type: 'GIS8',
            },
        ],
    }
];
